import { createContext } from 'react'

const contextPayload = { canChangeRFI: false, canCreateRFI: false, isPrivate: undefined, userType: undefined }
const AuthProviderContext = createContext(contextPayload)

AuthProviderContext.displayName = 'auth-provider_context'

export default AuthProviderContext
